import React, { useEffect, useState } from "react"; import Menubar from "../Menubar";
import { Modal,Container, Row, Col, Table,Button } from "react-bootstrap";
import { store } from "../../App"; import { AiFillFileExcel, AiOutlineSearch } from "react-icons/ai"; 
import { exportToExcel, datetime, formatNumberIndianWithDecimal, generatePdf, commonSelectProps } from "../utils/commonFunctions"; 
import KpiService from "../../Services/KpiService"; import AlertModal from "../Alert/AlertModal"; 
import useAlert from "../Alert/useAlert"; import { Field, FormikProvider, Form, useFormik } from "formik"; 
import MasterService from "../../Services/MasterService"; import { IoIosReturnLeft } from "react-icons/io"; import Select from 'react-select';

export default function AbstractReport() {
  const { showAlert, alertData,showAlertMessage, closeAlert } = useAlert(); 
  const [currentdate, setcurrentdate] = useState(""); const [currenttime, setcurrenttime] = useState(""); 
  const [Deptlist, setDeptlist] = useState([]); const [distlist, setDistrictList] = useState(); const [searchText, setSearch] = useState("");
  const[maintablenb,setmaintablenb]=useState(true);
  const [selecteddist,setselecteddist]=useState("");
  const [selectedmandal,setselectedmandal]=useState("");
  const [yearList,setYearList] = useState([]);
  const [kpidata, setKpidata] = useState([]);
  const [monthList, setMonthList] = useState([]);
  const [showDrillModal, setShowDrillModal] = useState(false);
const [drillData, setDrillData] = useState([]);
const [rangeTitle, setRangeTitle] = useState("");


  let ulbdeptlist=JSON.parse(localStorage.getItem("ulbdeptlist") || "[]"); let username = localStorage.getItem("username"); 
  let deptId = localStorage.getItem("deptid"); let district = localStorage.getItem("districtid"); let roleid = localStorage.getItem("catid");
  let mandalid = localStorage.getItem(ulbdeptlist.includes(deptId)?"ulbid":"mandalid");

  const formik = useFormik({
    initialValues: { department_id:"", district_id:"",year:"",  month: "",},
  });


  useEffect(() => {
    datetime(setcurrentdate, setcurrenttime);
    let params = { userId: username }
    MasterService.getAllDepts(params).then((res) => { 
      if (res.data) { let options = res.data?.SDESC.map((item, i) => { return (<option key={i} value={item.dept_id}> {item.dept_name} </option>); }); 
      setDeptlist([ { dept_id: "0", dept_name: "All" }, ...(res.data?.SDESC ?? []) ]); } });
    MasterService.getfinyears().then((achievvalueres) => { if (achievvalueres.data) { 
      let options = achievvalueres.data.map((item, i) => { return ( <option key={i} value={item.id}> {item.value} </option> ); });
               setYearList(achievvalueres.data); } });
    MasterService.getkpiMonths(params).then((res) => { if (res.data && res.data.SCODE === "01") { setMonthList(res.data.SDESC || []); } 
      else { setMonthList([]); } });
    MasterService.getDistricts().then((res17) => { if (res17.data) { 
      let options = res17.data.map((item, i) => { return (<option key={i} value={item.id}> {item.value} </option>); }); 
      setDistrictList(res17.data); } });

     if(["113","119","117","111"].includes(roleid)){setselecteddist(localStorage.getItem("districtname"))}
     if(["117","111"].includes(roleid)){setselectedmandal(localStorage.getItem(ulbdeptlist.includes(deptId)?"ulbname":"mandalname"))}
     if(["111","113","114","115"].includes(roleid)){formik.setFieldValue("department_id",deptId); }
     if(["113","114","111","115"].includes(roleid)){formik.setFieldValue("department_id",deptId); formik.setFieldValue("district_id",district); }
     if(["119","117"].includes(roleid)){ formik.setFieldValue("district_id",district); } }, []);

    const getAbstractReport = (monthValue) => {
      if (!monthValue) return;
      const params = { userId: username, districtId: district.toString(),
        month: monthValue.toString(), year: formik.values.year, deptId:formik.values.department_id };
      store.dispatch({ type: "SHOW_SPINNER" });
      KpiService.AbstractReport(params) .then((res) => {
          if (res.data && res.data.SCODE === "01") {
            setKpidata(res.data.dataList || []);
          } else {
            showAlertMessage(res.data.SDESC, "warning");
            setKpidata([]);
          } }) .catch(() => { showAlertMessage("Failed to fetch data. Please try again.", "warning"); })
        .finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });
    };

  const headerStyle = { backgroundColor: "#4e835c", color: "white", padding: "5px", border: "1px solid white",wordBreak: "break-word" };
  const totalRow = kpidata && kpidata.length ? kpidata[kpidata.length - 1] : null;
  const originalRows = kpidata && kpidata.length ? kpidata.slice(0, -1) : [];
  const filteredKpiData =
  searchText.length > 0 && originalRows?.length ? originalRows.filter((item) =>
        [ item.dept_name, item.achievedscore, item.achievedgrade, item.above_90,
          item.btwn_75_89, item.btwn_50_74, item.below_50, item.tot_ind ].some(
          (val) => val && val.toString().toLowerCase().includes(searchText.toLowerCase()) ) ) : originalRows;
const handleDrillDown = (range,deptid) => {
    let title = "";
  if (range === "above_90") title = "A+ (>90%)";
  else if (range === "btwn_75_89") title = "A (75-89%)";
  else if (range === "btwn_50_74") title = "B (50-74%)";
  else if (range === "below_50") title = "C (<50%)";
  setRangeTitle(title);
  const params = {
    userId: username,
    districtId: district.toString(),
    month: formik.values.month.toString(),
    year: formik.values.year,
    deptId:deptid,
    range: range
  };

  store.dispatch({ type: "SHOW_SPINNER" });
  KpiService.AbstractReportdrilldown(params)
    .then((res) => {
      if (res.data && res.data.SCODE === "01") {
        setDrillData(res.data.dataList || []); setShowDrillModal(true); } 
      else {
        showAlertMessage(res.data.SDESC || "No data found", "warning");
        setDrillData([]);
      } }) .catch(() => {
      showAlertMessage("Failed to fetch drilldown data", "warning");
      setDrillData([]);
    })
    .finally(() => {
      store.dispatch({ type: "HIDE_SPINNER" });
    });
};

const getRingColor = (score) => {
  if (score >= 90) return "#6cc04a";   // green
  if (score >= 75) return "#f7c600";   // yellow
  if (score >= 50) return "#2fb4ff";   // blue
  return "#ff5a5a";                    // red
};


const renderStatusRing = (score, maxScore = 100, size = 40, strokeWidth = 6) => {
  let parsedScore = parseFloat(score);
  if (isNaN(parsedScore) || parsedScore < 0) { parsedScore = 0; }
  const normalizedScore = Math.min(parsedScore, maxScore);
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const progress = (normalizedScore / maxScore) * circumference;
  const ringColor = getRingColor(normalizedScore);

  return (
    <svg width={size} height={size} style={{ display: "block" }}>
      <circle
        stroke="#e6e6e6"
        fill="transparent"
        strokeWidth={strokeWidth}
        r={radius}
        cx={size / 2}
        cy={size / 2}
      />

      <circle
        stroke={ringColor}
        fill="transparent"
        strokeWidth={strokeWidth}
        strokeDasharray={circumference}
        strokeDashoffset={circumference - progress}
        strokeLinecap="round"
        r={radius}
        cx={size / 2}
        cy={size / 2}
      />

      <text
        x="50%"
        y="50%"
        dominantBaseline="middle"
        textAnchor="middle"
        fill="#333"
        fontWeight="bold"
        fontSize={size / 4.3}
      >
        {normalizedScore}
      </text>
    </svg>
  );
};

const selectedDeptName = Deptlist?.find(
  (d) => d.dept_id === formik.values.department_id
)?.dept_name;

const selectedYearName = yearList?.find(
  (y) => y.id === formik.values.year
)?.value;

const selectedMonthName = monthList?.find(
  (m) => m.month_order === formik.values.month
)?.month_name;

  return (
    <>
      <Menubar />
      <Container fluid style={{ width: "96%" }}> <div className="sa-title"> <h2> Abstarct<span> Report </span> </h2> </div> </Container>
      <Container fluid style={{ width: "96%" }} className="outer-page-content-container">
        <FormikProvider value={formik}>
                  <Form onSubmit={formik.handleSubmit}>
                    <div className="py-2 px-4 mb-3">
                      <Row>
                         <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3}>
                          <label htmlFor="department_id" className="mb-1 fw-bold"> {" "} HOD Name </label> 
                          <Select 
                          {...commonSelectProps({
                              name: "department_id",
                              options: Deptlist,
                              value: formik.values.department_id,
                              optionValueKey: "dept_id",
                              optionLabelKey: "dept_name",
                              formik,
                              isDisabled: ["113", "114", "111","115"].includes(roleid),
                              extraOnChange: (option) => { formik.setFieldValue("year",""); formik.setFieldValue("month",""); setKpidata([]); }
                          })}
                        /> </Col>
                         {["113","119","117","111"].includes(roleid) && 
                         <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className='district-select'> <label className="mb-1 fw-bold">District</label> 
                          <Select {...commonSelectProps({ name: "district_id", options: distlist, value: formik.values.district_id,
                            optionValueKey: "id", optionLabelKey: "value", formik, isDisabled: true, extraOnChange: (option) => { } })}
                        /> </Col> } 
                        {["117","111"].includes(roleid) && 
                        <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className='district-select'> 
                        <label className="mb-1 fw-bold">{ulbdeptlist.includes(roleid === "111"?deptId:formik.values.department_id)?"ULB":"Mandal"}</label> 
                        <Field className="mb-3 form-control" name="mandal_id" type="text"  value={selectedmandal}  controlId="formBasicEmail" 
                        disabled={true} style={{ fontWeight: "bold" }}/> </Col> } 
                        <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3}>
                        <label className="mb-1 fw-bold"> Financial Year </label> <span style={{ color: "red" }}> *</span>
                        <Select 
                        {...commonSelectProps({ 
                          name: "year", 
                          options: yearList?.slice(1,2), 
                          value: formik.values.year,
                          optionValueKey: "id", 
                          optionLabelKey: "value", 
                          formik, 
                          isDisabled: false, 
                          extraOnChange: (option) => {  formik.setFieldValue("month",""); } 
                        })} /> </Col>
                        <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3}> 
                        <label className="mb-1 fw-bold">Month</label> <span style={{ color: "red" }}> *</span>
                        <Select 
                        {...commonSelectProps({ 
                          name: "month", 
                          options: monthList, 
                          value: formik.values.month, 
                          optionValueKey: "month_order", 
                          optionLabelKey: "month_name", 
                          formik,
                          isDisabled: false,
                          extraOnChange: (option) => {
                          const monthValue = option ? option.month_order : ""; 
                          if ( monthValue && formik.values.year && formik.values.department_id ) { 
                            getAbstractReport(monthValue); } }
                        })} /> </Col>
                      </Row> </div> </Form> </FormikProvider>
  
        {maintablenb && <> <Row>
          <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className=" mb-3">
            <div style={{ alignItems: "center",display: "flex",  border: "1px solid #ddd", borderRadius: "20px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", transition: "all 0.3s ease-in-out", backgroundColor: "#fff", padding: "5px 10px", width: "150px", minWidth: "150px" }} id="search-container">
              <AiOutlineSearch className="me-2" style={{ color: "#888", fontSize: "1.2rem", visibility: "visible" }} />
              <input type="text" value={searchText} placeholder="Search"   
              onFocus={(e) => { const parent = e.currentTarget.parentElement; parent.style.boxShadow = "0 6px 12px rgba(0, 0, 0, 0.2)"; parent.style.border = "1px solid #353935"; parent.style.width = "100%"; }}
              onChange={(e) => setSearch(e.target.value)}onBlur={(e) => { const parent = e.currentTarget.parentElement; parent.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.1)"; parent.style.border = "1px solid #ddd"; parent.style.width = "150px"; }} style={{ flex: "1", border: "none", outline: "none", fontSize: "1rem", color: "#333", backgroundColor: "transparent", transition: "color 0.3s ease", minWidth: "0" }} />
            </div> </Col>
          <Col className="mb-2"> <button size="sm" className="btn mx-2 excel-btn"  
           onClick={() => exportToExcel("my-table", "AbstractReport")} style={{ float: "right", color: "#ffffff", marginLeft: "3px" }}> Excel <AiFillFileExcel style={{ fontSize: "18px" }} /> </button>
          </Col>
        </Row>
        <div style={{ textAlign: "center", backgroundColor: "#d4e3d8" }} className="rounded-1 border py-1" >
          <span className="style"> Department Wise Grades for overall KPIs </span>
          <div className="style" style={{ fontSize: "14px", marginTop: "4px" }}>
            HOD: {selectedDeptName || "-"} &nbsp;&nbsp;
           Financial Year: {selectedYearName || "-"} &nbsp;&nbsp;
           Month: {selectedMonthName || "-"}
          </div>
          <div className="text-end style-1"> Report On : {currentdate} {currenttime} </div>
        </div>

        <div id="table-scroll" className="table-scroll"> <div className="table-wrap">
         <Table bordered id="my-table" className="custom-table table-responsive table table-bordered sticky-table">
          <thead>
            <tr className="text-center">
              <th style={headerStyle} rowSpan={2}>Sl.No.</th>
              <th  style={{ ...headerStyle, minWidth: "200px" }} rowSpan={2}>Name of the Department</th>
              <th style={headerStyle} rowSpan={2}>Score</th>
              <th style={headerStyle} rowSpan={2} >Grade</th>
              <th style={headerStyle} colSpan={5} >No. of Indicators</th> </tr><tr>
              <th style={{ ...headerStyle, backgroundColor: "#9ED286", color: "#000" }}> <span> A+ <br /> (&gt;90%) </span> </th>
              <th style={{ ...headerStyle, backgroundColor: "#FFCD1E", color: "#000" }}> <span> A <br />(75%-89%)</span> </th>
              <th style={{ ...headerStyle, backgroundColor: "#3DD9FF", color: "#000" }}> <span> B <br />(50%-74%)</span> </th>
              <th style={{ ...headerStyle, backgroundColor: "#FF6E74", color: "#000" }}> <span> C <br /> (&lt;50%) </span> </th>
              <th style={headerStyle} > <span> Grand Total </span> </th></tr>
          </thead>
          <tbody>
          {filteredKpiData && filteredKpiData.length > 0 ? (
            filteredKpiData.map((item, index) => (
              <tr key={index} className="text-center"  > 
                <td  style={{ textAlign: "center" }} >{index + 1}</td>
                <td style={{ textAlign: "left", minWidth: "200px" }} > {item.deptcode}<br></br>{item.dept_name} </td>
                <td style={{ textAlign: "right" }} > {item.achievedscore} </td>
                <td style={{ backgroundColor: item.color_code, fontWeight: "bold" }} > {item.achievedgrade} </td>
                <td style={{ textAlign: "right",color:"blue" }}   onClick={() => handleDrillDown("above_90",item.dept_id)}>{item.above_90}</td>
                <td style={{ textAlign: "right",color:"blue" }}  onClick={() => handleDrillDown("btwn_75_89",item.dept_id)}>{item.btwn_75_89}</td>
                <td style={{ textAlign: "right" ,color:"blue"}}  onClick={() => handleDrillDown("btwn_50_74",item.dept_id)}>{item.btwn_50_74}</td>
                <td style={{ textAlign: "right" ,color:"blue"}}  onClick={() => handleDrillDown("below_50",item.dept_id)}>{item.below_50}</td>
                <td style={{ textAlign: "right" }}>{item.tot_ind}</td>
              </tr>
            )) ) : (
            <tr> <td colSpan="9" className="text-center"> No Data Available </td> </tr>
          )}
          </tbody>
          <tfoot>
            {totalRow && (kpidata.length!==1) && ( <>
                <tr style={{ fontWeight: "bold", backgroundColor: "#f2f2f2" }}>
                   <td colSpan={4}  style={{ textAlign: "center" }}>Grand Total</td> 
                  <td style={{ textAlign: "right" }}>{totalRow.above_90}</td>
                  <td style={{ textAlign: "right" }}>{totalRow.btwn_75_89}</td>
                  <td style={{ textAlign: "right" }}>{totalRow.btwn_50_74}</td>
                  <td style={{ textAlign: "right" }}>{totalRow.below_50}</td>
                  <td style={{ textAlign: "right" }}>{totalRow.tot_ind}</td>
                </tr>
              </> )} </tfoot> </Table> </div> </div> </>}
       </Container>
               <Modal show={showDrillModal} onHide={() => setShowDrillModal(false)} size="lg" centered>
  <Modal.Header closeButton style={{ backgroundColor: "#4e835c", color: "#fff" }}>
    <Modal.Title>{rangeTitle}-Indicator Details</Modal.Title>
     <Col className="mb-2">
           {/*<button className="btn btn-danger btn-sm mx-2 pdf-btn"  style={{ float: "right", marginLeft: "3px" }} onClick={() => generatePdf("#my-table", "indicatorWiseProgressReport",76)} > PDF <MdOutlinePictureAsPdf /> </button>*/}
           <button size="sm" className="btn mx-2 excel-btn"  
           onClick={() => exportToExcel("my-table2", "AbstractReport-Drilldown")} style={{ float: "right", color: "#ffffff", marginLeft: "3px" }}> Excel <AiFillFileExcel style={{ fontSize: "18px" }} /> </button>
          </Col>
  </Modal.Header>

  <Modal.Body>
    <Table bordered hover id="my-table2" className="custom-table table-responsive table table-bordered sticky-table">
  <thead>
    <tr>
      <th style={{ width: "80px" }}>Sl.No</th>
      <th>Indicator Name</th>
      <th style={{ width: "150px", textAlign: "right" }}>Achieved Score (%)</th>
    </tr>
  </thead>

      <tbody>
        {Array.isArray(drillData) && drillData.length > 0 ? (
          drillData.map((item, index) => (
            <tr key={index}>
              <td>{index + 1}</td>
              <td>{item.indicator_name}</td>
             <td style={{ textAlign: "center", verticalAlign: "middle", display: "flex", justifyContent: "center", alignItems: "center" }}>
            {renderStatusRing(item?.capped_achieved_score, 100, 40, 6)}
          </td>
         
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan="3" className="text-center">
              No Data Available
            </td>
          </tr>
        )}
      </tbody>
    </Table>
  </Modal.Body>

  <Modal.Footer>
    <Button variant="primary"  className="cancel"  onClick={() => setShowDrillModal(false)}>
      Close
    </Button>
  </Modal.Footer>

</Modal>
      <AlertModal show={showAlert} titleText={alertData.titleText} alertText={alertData.alertText} onClose={closeAlert} />
    </>
  );
}
